var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors),expression:"hasErrors"}],staticClass:"alert alert-danger",attrs:{"data-dusk":"validation-errors"}},[_c('ul',_vm._l((_vm.flatErrors),function(error){return _c('li',[_vm._v(_vm._s(error))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }